import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-ce-review-task-content',
    templateUrl: './ce-review-task-content.component.html',
    imports: [FormsModule]
})
export class CeReviewTaskContentComponent {
  @Input()
  task: {
    humanizedType: string;
    notes: string;
  };
}
